import { API_BASE_URL, SERVICEURL, USERTYPES } from "../constants/Constants";
import axios from "axios";
import { getItem } from "../helpers/LocalStorageUtility";
import { APIs } from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";

export const fetchOptionsData = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.HP_GET_OPTIONS_LIST);
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const fetchSysOptionsData = async () => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.HP_GET_OPTIONS_LIST_SYS);
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const fetchHPData = async (id) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.HP_GET, {
      data: {
        id,
      },
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const fetchSysHPData = async (id) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.HP_GET_SYS, {
      data: {
        id,
      },
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const fetchHPList = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.HP_GET_LIST, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const fetchSysHPList = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.HP_GET_LIST_SYS, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const addHP = async (values) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.HP_ADD,values, 
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const addSysHP = async (values) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.HP_ADD_SYS,values, 
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const editHP = async (values) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.HP_EDIT,values, 
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const editSysHP = async (values) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.HP_EDIT_SYS,values, 
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const changeStatusHP = async (id, status) => {
  const body = {
    hpId: id,
    status: status ? 1 : -1,
  };
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.HP_ACITVATE_DEACTIVE, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};


export const changeSysStatusHP = async (id, status) => {
  const body = {
    hpId: id,
    status: status ? 1 : -1,
  };
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.HP_ACITVATE_DEACTIVE_SYS, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const deleteHP = async (id) => {
  const body = {
    hpId: id
  };
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.HP_DETETE, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const deleteSysHP = async (id) => {
  const body = {
    hpId: id
  };
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + APIs.HP_DETETE_SYS, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};